<template>
  <div>
    <el-dialog
      class="modal"
      title="APIKey"
      :visible.sync="keyModal"
      width="375px"
    >
      <el-tooltip
        v-if="keyModal"
        style="cursor:pointer"
        v-clipboard:copy="currentData.customer.api_key"
        v-clipboard:success="$onCopy"
        class="item copyHover"
        effect="dark"
        content="點擊複製"
        placement="top"
      >
        <p>
          {{ currentData.customer.api_key }}
        </p>
      </el-tooltip>
      <el-dialog
        width="375px"
        title="是否更換APIKey"
        :visible.sync="keyInner"
        append-to-body
      >
        <p>商戶{{ currentData.customer_id }}</p>
        <el-form :model="currentData" label-position="top" v-if="keyModal">
          <el-form-item label="請輸入驗證碼">
            <el-input
              v-model="oneCode"
              autocomplete="off"
              placeholder="驗證碼"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer btnGroup">
          <div @click="keyInner = false" class="btn">關閉</div>
          <div @click="confirmChangeKey" class="btn">確認</div>
        </div>
      </el-dialog>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="keyModal = false" class="btn">關閉</div>
        <div @click="keyInner = true" class="btn">更換APIKey</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="高換高級代理"
      :visible.sync="changeAgentModal"
      width="375px"
    >
      <p style="text-align:center">用戶:{{ currentData.id }}</p>
      <p class="text-danger" style="text-align:center">更換後費率需重新設定</p>
      <el-form
        :model="currentData"
        label-position="top"
        v-if="changeAgentModal"
      >
        <el-form-item label="高級代理ID">
          <el-select
            filterable
            v-model="currentData.changeID"
            placeholder="請選擇高級代理ID"
          >
            <el-option
              :label="agent.user_id"
              :value="agent.user_id"
              v-for="agent in agentList"
              :key="agent.user_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="請輸入驗證碼">
          <el-input
            v-model="oneCode"
            autocomplete="off"
            placeholder="驗證碼"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="changeAgentModal = false" class="btn">關閉</div>
        <div @click="confirmChangeAgent" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="代收、代付姓名黑名單"
      :visible.sync="userBlackModal"
      width="375px"
    >
      <p style="text-align:center">用戶:{{ currentData.id }}</p>
      <p class="text-danger" style="text-align:center">換行做分隔</p>
      <el-form :model="currentData" label-position="top" v-if="userBlackModal">
        <el-form-item label="請輸入姓名">
          <el-input
            type="textarea"
            v-model="currentData.currentUserNames"
            autocomplete="off"
            placeholder="請輸入姓名"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="userBlackModal = false" class="btn">關閉</div>
        <div @click="confirmEditUserBlack" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="編輯用戶白名單"
      :visible.sync="editIPModal"
      width="375px"
    >
      <p class="text-danger" style="text-align:center">換行做分隔</p>
      <el-form :model="currentData" label-position="top" v-if="editIPModal">
        <el-form-item label="用戶登入IP白名單">
          <el-input
            type="textarea"
            v-model="currentData.allowed_ips[0].ips"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="提現IP白名單">
          <el-input
            type="textarea"
            v-model="currentData.allowed_ips[1].ips"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="代付IP設定"
          v-if="currentData.role_name == 'customer'"
        >
          <el-input
            type="textarea"
            v-model="currentData.allowed_ips[2].ips"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="接口IP設定"
          v-if="currentData.role_name == 'customer'"
        >
          <el-input
            type="textarea"
            v-model="currentData.allowed_ips[3].ips"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="驗證碼">
          <el-input v-model="oneCode" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="editIPModal = false" class="btn">關閉</div>
        <div @click="confirmEditIP" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="編輯用戶"
      :visible.sync="editUserModal"
      width="80%"
    >
      <p style="text-align:center">用戶 {{ currentData.id }}</p>
      <p
        style="text-align:center;color:red"
        v-if="currentData.role_name == 'agent'"
      >
        更動系統費 將導致高代相關渠道需重新設置
      </p>
      <p
        style="text-align:center;color:red"
        v-if="currentData.role_name == 'agent'"
      >
        代理提現同卡號限制次數:0表示不限制
      </p>
      <el-tabs v-model="activeName" v-if="editUserModal">
        <el-tab-pane label="基本資料" name="1">
          <el-form inline :model="currentData" label-position="top">
            <el-form-item label="用戶號" label-width="80px">
              <el-input
                disabled
                v-model="currentData.id"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="用戶類型" label-width="80px">
              <el-input
                disabled
                v-model="currentData.role_name_ch"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="用戶名稱" label-width="80px">
              <el-input
                v-model="currentData.name"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="系統費"
              label-width="80px"
              v-if="currentData.agent"
            >
              <el-input
                v-model="currentData.agent.system_rate"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="手機號碼" label-width="80px">
              <el-input
                v-model="currentData.phone"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item label="電子信箱" label-width="80px">
              <el-input
                v-model="currentData.email"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="限速設置" name="3" v-if="currentData.customer">
          <el-form inline :model="currentData" label-position="left">
            <el-form-item label="代收下單限速開關" label-width="auto">
              <el-switch
                active-color="#13ce66"
                inactive-color="#ff4949"
                :value="currentData.customer.limit_enable == 1"
                @change="
                  currentData.customer.limit_enable == 1
                    ? (currentData.customer.limit_enable = 0)
                    : (currentData.customer.limit_enable = 1)
                "
              ></el-switch>
              <span class="text-danger" style="margin-left:5px"
                >(分鐘設置1,嘗試次數設置60,即每1分鐘,可請求60次,啟用時段未設置,即全日啟用)</span
              >
            </el-form-item>
          </el-form>
          <el-form
            inline
            :model="currentData"
            label-position="left"
            v-if="currentData.customer.limit_enable == 1"
          >
            <el-form-item label="分鐘" label-width="auto">
              <el-input
                v-model="currentData.customer.limit_decay_minutes"
                autocomplete="off"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="嘗試次數" label-width="auto">
              <el-input
                v-model="currentData.customer.limit_max_attempts"
                autocomplete="off"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="啟用時段" label-width="auto">
              <el-time-picker
                placeholder="啟用時段"
                format="HH:mm"
                value-format="HH:mm"
                v-model="currentData.customer.limit_start_time"
              >
              </el-time-picker>
              -
              <el-time-picker
                placeholder="啟用時段"
                format="HH:mm"
                value-format="HH:mm"
                v-model="currentData.customer.limit_end_time"
              >
              </el-time-picker>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="代收設置" name="4" v-if="currentData.agent">
          <el-form inline :model="currentData" label-position="top">
            <el-form-item label="相同實名不可重複配單" label-width="auto">
              <el-switch
                active-color="#13ce66"
                inactive-color="#ff4949"
                :value="currentData.agent.user_name_enable == 1"
                @change="
                  currentData.agent.user_name_enable == 1
                    ? (currentData.agent.user_name_enable = 0)
                    : (currentData.agent.user_name_enable = 1)
                "
              ></el-switch>
            </el-form-item>
            <el-form-item
              label="分鐘數(未設置系統預設30分鐘)"
              label-width="auto"
              v-if="currentData.agent.user_name_enable == 1"
            >
              <el-input
                v-model="currentData.agent.user_name_time"
                autocomplete="off"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              label="次數(未設置系統預設1次)"
              label-width="auto"
              v-if="currentData.agent.user_name_enable == 1"
            >
              <el-input
                v-model="currentData.agent.user_name_limit"
                autocomplete="off"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="代付提現設置" name="5" v-if="currentData.agent">
          <el-form :model="currentData" label-position="top">
            <el-form-item label="代付提現同卡號限制次數" label-width="auto">
              <el-input
                min="0"
                onkeyup="value=value.replace(/^(-1+)|[^\d]+/g,'')"
                style="width:200px"
                v-model="currentData.agent.p_times"
                autocomplete="off"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="排除限制商戶號(換行做分隔)" label-width="auto">
              <el-input
                type="textarea"
                v-model="currentData.c_p_times_ignore"
                autocomplete="off"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="editUserModal = false" class="btn">關閉</div>
        <div @click="confirmEditUser" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="修改密碼"
      :visible.sync="editPasswordModal"
      width="375px"
    >
      <el-form :model="editPasswordData" label-position="top">
        <el-form-item label="密碼" label-width="80px">
          <el-input
            v-model="editPasswordData.password"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="提款密碼" label-width="80px">
          <el-input
            v-model="editPasswordData.withdraw_password"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="2FA驗證碼" label-width="80px">
          <el-input v-model="oneCode" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="editPasswordModal = false" class="btn">關閉</div>
        <div @click="confirmEditPassword" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="重設2FA"
      :visible.sync="reset2FAModal"
      width="375px"
    >
      <div>確認重設 {{ currentData.id }} 2FA?</div>
      <el-form :model="currentData" label-position="top">
        <el-form-item label="驗證碼" label-width="80px">
          <el-input v-model="oneCode" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="reset2FAModal = false" class="btn">取消</div>
        <div @click="confirmReset2FA" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      :title="'修改' + switchData.editTitle"
      :visible.sync="editSwitchModal"
      width="375px"
    >
      <div>
        確認{{ currentData[currentData.assign] == 1 ? "關閉" : "開啟" }}
        {{ currentData.id }} ?
      </div>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="editSwitchModal = false" class="btn">取消</div>
        <div @click="confirmEditSwitch" class="btn">確認</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="編輯凍結金額"
      :visible.sync="freezeBalanceModal"
      width="375px"
    >
      <el-form :model="changeBalanceData" label-position="top">
        <el-form-item label="金額" label-width="80px">
          <el-radio v-model="radio1" label="freeze">凍結金額</el-radio>
          <el-radio v-model="radio1" label="unfreeze">解凍金額</el-radio>
          <el-input
            type="number"
            v-model="changeBalanceData.amount"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="備註" label-width="80px">
          <el-input
            type="textarea"
            :rows="2"
            v-model="changeBalanceData.note"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="驗證碼" label-width="80px">
          <el-input v-model="oneCode" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="freezeBalanceModal = false" class="btn">取消</div>
        <div @click="confirmFreezeBalance" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="編輯可結算資金"
      :visible.sync="editBalanceModal"
      width="375px"
    >
      <el-form :model="changeBalanceData" label-position="top">
        <el-form-item label="金額" label-width="80px">
          <el-radio v-model="radio" label="add">增加</el-radio>
          <el-radio v-model="radio" label="reduce">減少</el-radio>
          <el-input
            type="number"
            v-model="changeBalanceData.amount"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="備註" label-width="80px">
          <el-input
            type="textarea"
            :rows="2"
            v-model="changeBalanceData.note"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="驗證碼" label-width="80px">
          <el-input v-model="oneCode" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="editBalanceModal = false" class="btn">取消</div>
        <div @click="confirmChangeBalance" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-form :inline="true" :model="searchData" class="demo-form-inline">
      <el-form-item label="用戶號/用戶名">
        <el-input
          v-model="searchData.user_id_name"
          placeholder="用戶號/用戶名"
        ></el-input>
      </el-form-item>
      <el-form-item label="用戶類型">
        <el-select v-model="searchData.role_name" placeholder="用戶類型">
          <el-option label="全部" value=""></el-option>
          <el-option label="商戶" value="customer"></el-option>
          <el-option label="一般代理" value="subagent"></el-option>
          <el-option label="高級代理" value="agent"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="
            page = 1;
            inSearch = true;
            saveData = false;
            getData();
          "
          >搜尋</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      stripe
      :data="dataList"
      border
      style="width: 100%;margin-top:18px"
    >
      <af-table-column
        :min-width="50"
        :key="1"
        header-align="center"
        align="center"
        prop="id"
        label="商戶號"
      >
      </af-table-column>
      <af-table-column
        :min-width="50"
        :key="2"
        header-align="center"
        align="center"
        prop="role_name_ch"
        label="用戶類型"
      >
      </af-table-column>
      <af-table-column
        :min-width="50"
        :key="3"
        header-align="center"
        align="center"
        prop="username"
        label="用戶帳號"
      >
      </af-table-column>
      <af-table-column
        :min-width="50"
        :key="4"
        header-align="center"
        align="center"
        prop="name"
        label="用戶名稱"
      >
      </af-table-column>
      <af-table-column
        :min-width="50"
        v-if="
          $store.state.userStatus != 'customer' &&
            $store.state.userStatus != 'customerSub' &&
            $store.state.userStatus != 'subagent' &&
            $store.state.userStatus != 'agent' &&
            $store.state.userStatus != 'agentSub'
        "
        :key="5"
        header-align="center"
        align="center"
        prop="currency"
        label="幣別"
      >
        <template slot-scope="scope">
          <div>
            <p v-if="scope.row.currency">{{ scope.row.currency.ch }}</p>
          </div>
        </template>
      </af-table-column>
      <af-table-column
        width="150"
        :key="6"
        header-align="center"
        align="center"
        prop="type_ch"
        label="可結算資金"
      >
        <template slot-scope="scope">
          <div>
            {{
              scope.row.agent_cost_fee
                ? Number(scope.row.balance) +
                  Number(scope.row.agent_cost_fee.cost_fee)
                : scope.row.balance | decimalPoint
            }}
            <span
              v-if="
                $permission('users.list.changeBalance') &&
                  ($store.state.userStatus == 'agent'
                    ? scope.row.role_name == 'customer'
                    : true)
              "
              @click="changeBalance(scope.row)"
            >
              <i class="fas fa-pen ml-1 pointer"></i>
            </span>
          </div>
        </template>
      </af-table-column>
      <af-table-column
        width="150"
        :key="7"
        header-align="center"
        align="center"
        prop="type_ch"
        label="凍結金額"
        v-if="
          $store.state.userStatus == 'customer' ||
            $store.state.userStatus == 'customerSub' ||
            $store.state.userStatus == 'agent' ||
            $store.state.userStatus == 'agentSub' ||
            $store.state.userStatus == 'administrator' ||
            $store.state.userStatus == 'staffSub' ||
            $store.state.userStatus == 'staff'
        "
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.freeze_balance | decimalPoint }}
            <span
              v-if="
                $permission('users.list.balanceFreeze') &&
                  ($store.state.userStatus == 'agent'
                    ? scope.row.role_name == 'customer'
                    : true)
              "
              @click="changeFreezeBalance(scope.row)"
            >
              <i class="fas fa-pen ml-1 pointer"></i>
            </span>
          </div>
        </template>
      </af-table-column>
      <af-table-column
        :key="8"
        header-align="center"
        align="center"
        prop="type_ch"
        label="用戶操作"
      >
        <template slot-scope="scope">
          <div style="display:flex;padding:0 10px;">
            <el-button
              size="mini"
              v-if="$permission('admin')"
              @click="$openUser(scope.row.id)"
            >
              登入
            </el-button>
            <el-button
              size="mini"
              v-if="$permission('users.list.update')"
              @click="editPassword(scope.row)"
            >
              修改密碼
            </el-button>
            <el-button
              size="mini"
              v-if="$permission('users.list.update')"
              @click="editUser(scope.row)"
            >
              編輯用戶
            </el-button>
            <el-button
              size="mini"
              v-if="$permission('users.list.allowedIpAddresses.store')"
              @click="editUserIP(scope.row)"
            >
              白名單
            </el-button>
            <el-button
              size="mini"
              v-if="scope.row.role_name == 'agent'"
              @click="editUserBlack(scope.row)"
            >
              姓名黑名單
            </el-button>
            <el-button
              size="mini"
              v-if="
                scope.row.role_name != 'agent' &&
                  scope.row.role_name != 'agentSub' &&
                  $permission('users.list.changeAgent')
              "
              class="btn btn-green ml-1"
              @click="changeAgent(scope.row)"
            >
              更換高級代理
            </el-button>
            <el-button
              size="mini"
              v-if="$permission('users.list.customers.reflashAPIKey')"
              @click="showKey(scope.row)"
            >
              APIKey
            </el-button>
            <el-button
              size="mini"
              v-if="
                (scope.row.role_name == 'customer' ||
                  $store.state.userStatus == 'customerSub') &&
                  $store.state.userStatus != 'subagent' &&
                  $store.state.userStatus != 'customer' &&
                  $store.state.userStatus != 'customerSub'
              "
              @click="channelTest(scope.row.id)"
            >
              渠道测试
            </el-button>
          </div>
        </template>
      </af-table-column>
      <af-table-column
        width="150"
        :key="9"
        header-align="center"
        align="center"
        prop="type_ch"
        label="啟用狀態"
        v-if="$permission('users.list.enable')"
      >
        <template slot-scope="scope">
          <!-- enable_create_transaction -->
          <div>
            <el-switch
              :value="scope.row.status == 1"
              @change="
                changeSwitch(
                  scope.row,
                  'status',
                  '啟用狀態',
                  `/back/users/${scope.row.id}/enable`
                )
              "
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
          </div>
        </template>
      </af-table-column>
      <!-- <af-table-column
        :min-width="50"
        :key="10"
        header-align="center"
        align="center"
        prop="type_ch"
        label="充值狀態"
      >
        <template slot-scope="scope">
          <div
            v-if="
              (scope.row.role_name == 'customer' ||
                $store.state.userStatus == 'customerSub') &&
                scope.row.customer != null
            "
          >
            <el-switch
              :value="scope.row.customer.enable_create_transaction == 1"
              @change="
                changeSwitch(
                  scope.row,
                  'enable_create_transaction',
                  '充值狀態',
                  `/back/customers/${scope.row.id}/switchDeposit`
                )
              "
              active-color="#13ce66"
              inactive-color="#ff4949"
              v-if="$permission('users.list.switchDeposit')"
            >
            </el-switch>
          </div>
        </template>
      </af-table-column> -->
      <af-table-column
        width="150"
        :key="11"
        header-align="center"
        align="center"
        prop="type_ch"
        v-if="$permission('users.list.reset2FA')"
        label="2FA驗證"
      >
        <template slot-scope="scope">
          <div>
            <el-button size="mini" @click="reset2FA(scope.row)">重設</el-button>
          </div>
        </template>
      </af-table-column>
      <af-table-column
        :min-width="50"
        :key="12"
        header-align="center"
        align="center"
        prop="created_at"
        label="註冊時間"
      >
      </af-table-column>
      <af-table-column
        width="150"
        :key="13"
        header-align="center"
        align="center"
        prop="type_ch"
        label="最近登入"
      >
        <template slot-scope="scope">
          <div>
            {{
              scope.row.login_logs.length
                ? scope.row.login_logs[0].datetime
                : "未更新"
            }}
          </div>
        </template>
      </af-table-column>
    </el-table>
    <div class="page">
      <el-pagination
        :current-page.sync="page"
        layout="prev, pager, next"
        :page-count="pagination.total_page"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dataList: [],
      searchData: {},
      saveData: false,
      page: 1,
      inSearch: false,
      pagination: {},
      editBalanceModal: false,
      changeBalanceData: {},
      radio: "add",
      oneCode: "",
      currentData: {},
      freezeBalanceModal: false,
      radio1: "freeze",
      switchData: {},
      editSwitchModal: false,
      reset2FAModal: false,
      editPasswordModal: false,
      editPasswordData: {},
      editUserModal: false,
      activeName: "1",
      editIPModal: false,
      userBlackModal: false,
      agentList: [],
      changeAgentModal: false,
      keyModal: false,
      keyInner: false,
      saveCurrentData: {}
    };
  },
  watch: {
    page() {
      if (this.inSearch) {
        this.inSearch = false;
        return;
      }
      this.getData();
    }
  },
  methods: {
    channelTest(customerId) {
      window.open(
        `${process.env.VUE_APP_DEFAULT_CTC}demo_member?member=${customerId}`
      );
    },
    confirmChangeKey() {
      this.$http
        .post(`/back/customers/reflashAPIKey`, {
          customer_id: this.currentData.id,
          oneCode: this.oneCode
        })
        .then(res => {
          if (res.data.code == 0) {
            this.$message.success("成功");
            this.keyModal = false;
            this.keyInner = false;
            this.getData();
          }
        });
    },
    showKey(user) {
      this.currentData = JSON.parse(JSON.stringify(user));
      this.keyModal = true;
      this.oneCode = "";
    },
    confirmChangeAgent() {
      this.$http
        .put(`/back/users/changeAgent`, {
          agent_id: this.currentData.changeID,
          oneCode: this.oneCode,
          user_id: this.currentData.id
        })
        .then(res => {
          if (res.data.code == 0) {
            this.changeAgentModal = false;
            this.currentData = {};
            this.$message.success("成功");
            this.getData();
          }
        });
    },
    changeAgent(user) {
      let users = JSON.parse(JSON.stringify(user));
      this.$http.get(`/back/agents`).then(res => {
        if (res.data.code == 0) {
          this.agentList = res.data.data;
        } else {
          this.agentList = [];
        }
      });
      this.oneCode = "";
      this.currentData = JSON.parse(JSON.stringify(users));
      this.changeAgentModal = true;
    },
    confirmEditUserBlack() {
      let data = JSON.parse(JSON.stringify(this.currentData));
      let sendData = JSON.parse(
        JSON.stringify(this.currentData.currentUserNames)
      );
      sendData = sendData.split("\n").filter(e => {
        return e != "";
      });
      data.user_id = data.id;
      data.df_block_name = sendData;
      this.$http.put(`/back/users/${this.currentData.id}`, data).then(res => {
        if (res.data.code == 0) {
          this.currentData = {};
          this.$message.success("成功");
          this.getData();
          this.userBlackModal = false;
        }
      });
    },
    editUserBlack(user) {
      let data = JSON.parse(JSON.stringify(user));
      if (data.agent.df_block_name) {
        data.currentUserNames = data.agent.df_block_name
          .join()
          .replace(/,/g, "\n");
      } else {
        data.currentUserNames = "";
      }
      this.currentData = JSON.parse(JSON.stringify(data));
      this.userBlackModal = true;
    },
    confirmEditIP() {
      let data = JSON.parse(JSON.stringify(this.currentData));
      let saveData = JSON.parse(JSON.stringify(this.saveCurrentData));
      data.user_id = data.id;
      let sendData = [];
      data.allowed_ips.forEach((e, index) => {
        if (!e) return;
        if (e && data.role_name != "customer" && (e.type == 2 || e.type == 3)) {
          data.allowed_ips[e.type] = null;
          return;
        }
        let ips;
        ips = data.allowed_ips[index].ips.split("\n").filter(e => {
          return e != "";
        });
        saveData.allowed_ips.forEach(save => {
          if (
            save &&
            e.type == save.type &&
            String(e.ips) != String(save.ips)
          ) {
            sendData.push({
              user_id: data.id,
              type: e.type,
              ips
            });
          }
        });
      });
      if (!sendData.length) {
        this.editIPModal = false;
        return;
      }
      this.$http
        .post(`/back/allowedIpAddresses`, {
          ips: sendData,
          oneCode: this.oneCode
        })
        .then(res => {
          if (res.data.code == 0) {
            this.editIPModal = false;
            this.currentData = {};
            this.$message.success("成功");
            this.getData();
          }
        });
    },
    editUserIP(user) {
      let data = JSON.parse(JSON.stringify(user));
      let allowIp = [
        {
          ips: "",
          type: 0
        },
        {
          ips: "",
          type: 1
        },
        {
          ips: "",
          type: 2
        },
        {
          ips: "",
          type: 3
        }
      ];
      if (data.allowed_ips.length == 0) {
        data.allowed_ips[0] = {
          ips: "",
          type: 0
        };
        data.allowed_ips[1] = {
          ips: "",
          type: 1
        };
        if (data.role_name == "customer") {
          data.allowed_ips[2] = {
            ips: "",
            type: 2
          };
          data.allowed_ips[3] = {
            ips: "",
            type: 3
          };
        }
      } else {
        data.allowed_ips.forEach(ips => {
          if (
            data.role_name != "customer" &&
            (ips.type == 2 || ips.type == 3)
          ) {
            allowIp[ips.type] = null;
            return;
          }
          data.allowed_ips.forEach(all => {
            if (all.type == ips.type) {
              allowIp[all.type].ips = all.ips.join().replace(/,/g, "\n");
            }
          });
        });
      }
      data.allowed_ips = allowIp;
      this.oneCode = "";
      this.currentData = data;
      this.saveCurrentData = JSON.parse(JSON.stringify(data));
      this.editIPModal = true;
    },
    confirmEditUser() {
      let data = JSON.parse(JSON.stringify(this.currentData));
      data.user_id = this.currentData.id;
      if (this.currentData.customer) {
        data.role_name = this.currentData.role_name;
        data.enable_payment_api = this.currentData.customer.enable_payment_api;
        data.payment_fee_type = this.currentData.customer.payment_fee_type;
        data.limit_enable = this.currentData.customer.limit_enable;
        if (this.currentData.customer.limit_enable == 1) {
          data.limit_decay_minutes = this.currentData.customer.limit_decay_minutes;
          data.limit_end_time =
            this.currentData.customer.limit_end_time || null;
          data.limit_max_attempts = this.currentData.customer.limit_max_attempts;
          data.limit_start_time =
            this.currentData.customer.limit_start_time || null;
        }
        if (this.currentData.customer.enable_wallet_address) {
          data.enable_wallet_address = this.currentData.customer.enable_wallet_address;
          data.wallet_notify_url = this.currentData.customer.wallet_notify_url;
        }
      }
      let sendData = {};
      if (data.agent) {
        data.system_rate = data.agent.system_rate_f;
        data.p_times = data.agent.p_times;
        data.user_name_enable = data.agent.user_name_enable;
        if (data.user_name_enable == 1) {
          data.user_name_time = data.agent.user_name_time;
          data.user_name_limit = data.agent.user_name_limit;
        } else {
          delete data.user_name_time;
          delete data.user_name_limit;
        }
      }
      Object.keys(data).forEach(e => {
        if (data[e] !== "" && e != "currency") {
          sendData[e] = data[e];
        }
      });
      let send = true;
      if (sendData.role_name == "agent") {
        let arr = [];
        if (sendData.c_p_times_ignore != "" && sendData.c_p_times_ignore) {
          sendData.c_p_times_ignore.split("\n").forEach(num => {
            if (num.length != 0 && !Number(num)) {
              send = false;
              // this.$store.dispatch("modal/modalContent", "");
              return;
            }
            if (num != "") {
              arr.push(num.trim());
            }
          });
        }
        sendData.p_times_ignore = arr;
      }
      if (sendData.customer) {
        delete sendData.customer;
      }
      if (!send) return;
      delete sendData.c_p_times_ignore;
      this.$http
        .put(`/back/users/${this.currentData.id}`, sendData)
        .then(res => {
          if (res.data.code == 0) {
            this.editUserModal = false;
            this.getData();
            this.currentData = {};
            this.$message.success("成功");
          }
        });
    },
    editUser(user) {
      let data = JSON.parse(JSON.stringify(user));
      if (data.role_name == "agent") {
        if (data.agent.p_times_ignore) {
          data.c_p_times_ignore = data.agent.p_times_ignore
            .join()
            .replace(/,/g, "\n");
        } else {
          data.c_p_times_ignore = "";
        }
      }
      if (data.role_name == "customer") {
        if (!data.customer.limit_start_time)
          data.customer.limit_start_time = "00:00";
        if (!data.customer.limit_end_time)
          data.customer.limit_end_time = "00:00";
      }
      this.currentData = JSON.parse(JSON.stringify(data));
      this.activeName = "1";
      this.editUserModal = true;
    },
    confirmEditPassword() {
      let data = this.editPasswordData;
      data.oneCode = this.oneCode;
      data.user_id = this.currentData.id;
      data.role_name = this.currentData.role_name;
      this.$http.put(`/back/users/${this.currentData.id}`, data).then(res => {
        if (res.data.code == 0) {
          this.editPasswordModal = false;
          this.$message.success("成功");
        }
      });
    },
    editPassword(user) {
      this.currentData = JSON.parse(JSON.stringify(user));
      this.editPasswordModal = true;
      this.editPasswordData = {};
      this.oneCode = "";
    },
    confirmReset2FA() {
      this.$http
        .post(`/back/users/reset2FA/${this.currentData.id}`, {
          oneCode: this.oneCode
        })
        .then(res => {
          if (res.data.code == 0) {
            this.$message.success("成功");
            this.reset2FAModal = false;
          }
        });
    },
    reset2FA(user) {
      this.currentData = JSON.parse(JSON.stringify(user));
      this.reset2FAModal = true;
      this.oneCode = "";
    },
    confirmEditSwitch() {
      let changeData = {};
      changeData[this.currentData.assign] =
        this.currentData[this.currentData.assign] == 1 ? 0 : 1;
      this.$http.post(this.currentData.api, changeData).then(res => {
        if (res.data.code == 0) {
          this.editSwitchModal = false;
          this.getData();
        }
      });
    },
    changeSwitch(user, assign, title, api) {
      this.currentData = JSON.parse(JSON.stringify(user));
      this.currentData.assign = assign;
      this.currentData.api = api;
      this.switchData.editTitle = title;
      this.editSwitchModal = true;
      if (this.currentData.role_name == "customer" && title != "啟用狀態") {
        this.currentData[assign] = this.currentData.customer[assign];
      }
    },
    confirmFreezeBalance() {
      this.$http
        .post(`/back/users/${this.currentData.id}/balanceFreeze`, {
          amount: this.changeBalanceData.amount,
          note: this.changeBalanceData.note,
          oneCode: this.oneCode,
          type: this.radio1
        })
        .then(res => {
          if (res.data.code == 0) {
            this.freezeBalanceModal = false;
            this.$message.success("成功");
            this.getData();
          }
        });
    },
    changeFreezeBalance(user) {
      this.currentData = JSON.parse(JSON.stringify(user));
      this.freezeBalanceModal = true;
      this.oneCode = "";
      this.changeBalanceData = {};
    },
    confirmChangeBalance() {
      this.$http
        .post(`/back/users/changeBalance`, {
          amount: this.changeBalanceData.amount,
          note: this.changeBalanceData.note,
          oneCode: this.oneCode,
          type: this.radio,
          user_id: this.currentData.id
        })
        .then(res => {
          if (res.data.code == 0) {
            this.editBalanceModal = false;
            this.$message.success("成功");
            this.getData();
          }
        });
    },
    changeBalance(user) {
      this.currentData = JSON.parse(JSON.stringify(user));
      this.changeBalanceData = {};
      this.oneCode = "";
      this.editBalanceModal = true;
    },
    getData() {
      let searchData = {};
      if (this.saveData) {
        searchData = JSON.parse(JSON.stringify(this.saveData));
      } else {
        searchData = JSON.parse(JSON.stringify(this.searchData));
      }
      Object.keys(searchData).forEach(e => {
        if (!searchData[e] && String(searchData[e]) !== "0") {
          delete searchData[e];
        }
      });
      searchData.page = this.page;
      searchData.status = 0;
      this.$http.get(`/back/users`, { params: searchData }).then(res => {
        if (res.data.code == 0) {
          this.saveData = JSON.parse(JSON.stringify(searchData));
          this.inSearch = false;
          this.dataList = res.data.data;
          this.pagination = res.data.paginate;
        }
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>
